import {AssetLunarExchangeOptionPutDataTransferObjectDescription} from "../../../data/data-transfer-object-description/asset/AssetLunarExchangeOptionPutDataTransferObjectDescription"
import {AssetLunarExchangeOptionPutState} from "../../../data/data-transfer-object-state/asset/AssetLunarExchangeOptionPutState"
import {AssetLunarExchangeOptionPutDataTransferObject} from "../../../data/data-transfer-object/asset/AssetLunarExchangeOptionPutDataTransferObject"
import {PostBigIntField, PostBitMaskField, PostBooleanField, PostDateField, PostEnumField, PostFieldWrapper, PostInputField, PostNumberField, PostTextareaField} from "../../PostField"
import {RouterProps} from "../../RouterProps"
import {JSX} from "react"

type PostFieldProps = RouterProps & {
    state: AssetLunarExchangeOptionPutState
}

export const AssetLunarExchangeOptionPutField: Record<Capitalize<keyof AssetLunarExchangeOptionPutDataTransferObject>, (props: PostFieldProps) => JSX.Element> = {
    LunarAmount(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetLunarExchangeOptionPutDataTransferObjectDescription.lunarAmount}>
                <PostNumberField
                    {...props}
                    value={props.state.lunarAmount.value}
                    setter={props.state.lunarAmount.setter} />
            </PostFieldWrapper>
        )
    },
    SolarAmount(props: PostFieldProps): JSX.Element {
        return (
            <PostFieldWrapper
                {...props}
                title={AssetLunarExchangeOptionPutDataTransferObjectDescription.solarAmount}>
                <PostNumberField
                    {...props}
                    value={props.state.solarAmount.value}
                    setter={props.state.solarAmount.setter} />
            </PostFieldWrapper>
        )
    },
}

export function AssetLunarExchangeOptionPutFields(props: PostFieldProps) {
    return <>
        <AssetLunarExchangeOptionPutField.LunarAmount
            {...props}
            state={props.state} />
        <AssetLunarExchangeOptionPutField.SolarAmount
            {...props}
            state={props.state} />
    </>
}
